import { appSettings } from "core/config";
import ApiHeaderKey from "core/constants/api-header-key";
import { sessionManager } from "core/instances";
import UrlUtils from "core/lib/url-utils";
import BaseService from "./base.service";

const uaArea = "UserActivityLogging";

export type LogUser = {
    id: string,
    name: string,
    userType: string,
    firstName: string,
    lastName: string,
    email: string
}

export type UserActivityLog = {
    id: string;
    index: number;
    dateCreated: Date;
    date: string;
    time: string;
    userType: string;
    firstName: string;
    lastName: string;
    email: string;
    description: string;
}

class UserActivityLoggingService extends BaseService {
    userTracking = null;

    constructor() {
        super();
        this.setBaseUrl("UserActivityLogging");
    }

    protected getRequestHeaders() {
        const headers = super.getRequestHeaders();
        headers[ApiHeaderKey.businessUnit] = "DStv";
        return headers;
    }

    getUsers() {
        return this.createPromiseRequest(`users?customerNumber=${this.customerNumber}`).get<LogUser[]>();
    }

    getLogsAsync() {
        this.logActivityAsync(uaArea, "Read");

        return this.createPromiseRequest(`?customerNumber=${this.customerNumber}`).get<UserActivityLog[]>();
    }

    filterLogsAsync(request: any) {
        request.customerNumber = this.customerNumber;

        this.logActivityAsync(uaArea, "Read", request);

        return this.createPromiseRequest("?compact=true").post<UserActivityLog>(request);
    }

    downloadLogsAsync(request: any) {
        request.customerNumber = this.customerNumber;

        this.logActivityAsync(uaArea, "Download");

        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const path = `download?culture=${UrlUtils.getLanguageCode()}&timeZone=${timeZone}`;
        return this.createPromiseRequest(path)
            .withResponseType("arraybuffer")
            .post(request);
    }

    logActivityAsync(area: string, action: string, data: any | null = null) {
        if (!appSettings.isEnabled.userTracking) {
            return;
        }

        const request = {
            area,
            action,
            data
        };

        return this.createPromiseRequest("log")
            .withHeader("x-user", sessionManager.getUserDetailsForHeader())
            .post<boolean>(request);
    }
}

export default UserActivityLoggingService;
